const contractorRouter = [
  {
      path: "list-supplies-equipment",
      name: "supplies_equipment",
      component: () => import("@/views/admin/supplies_equipment"),
      default: true,
      meta: {
          model: "supplies_equipment",
          // requiresAuth: true,
      },
  },
  {
      path: "list-supplies-equipment/add",
      name: "addSuppliesEquipment",
      component: () => import("@/views/admin/supplies_equipment/function"),
      default: true,
      meta: {
          model: "supplies_equipment",
          // requiresAuth: true,
      },
  },
  {
      path: "list-supplies-equipment/edit/:id",
      name: "editSuppliesEquipment",
      component: () => import("@/views/admin/supplies_equipment/function"),
      default: true,
      meta: {
          model: "supplies_equipment",
          // requiresAuth: true,
      },
  }
]
export default contractorRouter;